import { theme } from '@prophecy/theme';
import { Input, LabelWithHint } from '@prophecy/ui-v3';
import React from 'react';
import { Controller } from 'react-hook-form';

import { getClientIdLabel, getCrendetialsLabel } from '../../utils';
import { ScrollableStack } from './styled';
import { ComponentProps } from './types';

export default function GoogleAuth({
  control,
  errors,
  isSCIMEnabled: _isSCIMEnabled,
  isSCIMV1: _isSCIMV1
}: ComponentProps) {
  return (
    <ScrollableStack gap={theme.spaces.x24}>
      {/*<Controller
        render={({ field }) => (
          <UserPrompt
            hasPrompt={!isSCIMEnabled || isSCIMV1}
            errorMsg={errors?.google?.usernamePrompt?.message}
            value={field.value}
            onChange={field.onChange}
          />
        )}
        control={control}
        name='google.usernamePrompt'
      />*/}
      <Controller
        render={({ field }) => (
          <Input
            label={<LabelWithHint hint={getClientIdLabel('google')}>* Client ID</LabelWithHint>}
            {...field}
            variant={errors?.google?.clientID ? 'error' : 'primary'}
            helpText={errors?.google?.clientID?.message}
            data-test-id='google-auth-client-id-input'
          />
        )}
        control={control}
        name='google.clientID'
        rules={{
          required: 'Client is required'
        }}
      />
      <Controller
        render={({ field }) => (
          <Input
            label={<LabelWithHint hint={getCrendetialsLabel('google')}>* Client Secret</LabelWithHint>}
            {...field}
            variant={errors?.google?.clientSecret ? 'error' : 'primary'}
            helpText={errors?.google?.clientSecret?.message}
            data-test-id='google-auth-client-secret-input'
          />
        )}
        control={control}
        name='google.clientSecret'
        rules={{
          required: 'Client secret is required'
        }}
      />
    </ScrollableStack>
  );
}
